import {
    DesktopOutlined,
    LineChartOutlined,
    FundProjectionScreenOutlined,
    FileUnknownFilled,
    EnvironmentOutlined    
  } from "@ant-design/icons";
  import { Menu } from "antd";
  import { useEffect, useState } from "react";
  import { useLocation, useNavigate,useParams } from "react-router-dom";

  function UpMenu() {
    const {cropid} = useParams();

    const location = useLocation();
    const [selectedKeys, setSelectedKeys] = useState("");
      
    useEffect(() => {  
      const pathName = location.pathname;    
      setSelectedKeys(pathName); 
        
    }, [location.pathname]);
  
    const navigate = useNavigate();
    return (
      <div className="UpMenu">
        <Menu
          className="UpMenuHorizontal"
          mode="horizontal"
          onClick={(item) => {
            navigate(item.key);
          }}
          selectedKeys={[selectedKeys]}
          items={[{
            label: "Monitor",
            icon: <DesktopOutlined />,
            key: `/farmer/${cropid}`,
          },
          {
            label: "Serie de tiempo",
            icon: <LineChartOutlined />,
            key: `/farmer/${cropid}/timeseries`,
          },
          {
            label: "Producción",
            key: `/farmer/${cropid}/production`,
            icon: <FundProjectionScreenOutlined />,
          },
          {
            label: "Agua",
            key: `/farmer/${cropid}/water`,
            icon: <EnvironmentOutlined rotate="180" />,
          },
        ]}        
          
        ></Menu>
        
      </div>
    );
  }
  export default UpMenu;
  